// TODO: fetch all Calii+ config server-side (free_delivery_threshold, monthly_credit,
// monthly_price, discount tiers, and copy strings) from the API instead of hardcoding here.
const CALII_PLUS_MIN_THRESHOLD = 300; // TODO: from API (free delivery threshold)
const CALII_PLUS_SUBTITLE = "$1000 de regalo al mes y envíos gratis"; // TODO: from API
const CALII_PLUS_DEFAULT_TITLE = "Recibe $1000 de regalo al mes y envíos gratis"; // TODO: from API

// TODO: fetch discount tiers from API — thresholds and copy may change.
// Sorted descending by minSubtotal — first matching tier wins.
const CALII_PLUS_TIERS = [
  { minSubtotal: 4000, title: "Recibe $250 OFF en este pedido" },
  { minSubtotal: 3000, title: "Recibe $200 OFF en este pedido" },
  { minSubtotal: 2250, title: "Recibe $150 OFF en este pedido" },
  { minSubtotal: 1500, title: "Recibe $100 OFF en este pedido" },
  { minSubtotal: 1200, title: "Recibe $80 OFF en este pedido" },
  { minSubtotal:  800, title: "Recibe $50 OFF en este pedido" },
  { minSubtotal:  300, title: "Recibe envío gratis en este pedido" },
] as const;

export function freeTrialLabel(months: number): string {
  return months === 1 ? "1 mes gratis" : `${months} meses gratis`;
}

export function getCaliiPlusMessage(
  subtotal: number,
  freeTrialMonths = 0,
): { title: string; subtitle: string | null } {
  const withCaliiPlusStr = freeTrialMonths > 0 ? `con ${freeTrialLabel(freeTrialMonths)} de Calii+` : "con Calii+";

  if (subtotal < CALII_PLUS_MIN_THRESHOLD) {
    return { title: `${CALII_PLUS_DEFAULT_TITLE} ${withCaliiPlusStr}`, subtitle: null };
  }
  
  const tier = CALII_PLUS_TIERS.find((t) => subtotal >= t.minSubtotal)!;
  return { title: `${tier.title} ${withCaliiPlusStr}`, subtitle: CALII_PLUS_SUBTITLE };
}
